angular.module('acme.view.application.importExport.importExportJob.directives.importExportJobMappings.modals.editor', [])
  .controller('ImportExportJobMappingsEditorModalController', ImportExportJobMappingsEditorModalController);

/**
 * Controller responsible for showing the user the downloadable Outputs for a Export Job Execution
 * @class ImportExportJobMappingsEditorModalController
 * @constructor
 * @return {ImportExportJobMappingsEditorModalController} - Class instance
 */
function ImportExportJobMappingsEditorModalController(
  $timeout,
  $uibModalInstance,
  HelpersService,
  ImportJobsApiService,
  job,
  mappings)
{
  Object.assign(this, {
    $timeout: $timeout,
    $uibModalInstance: $uibModalInstance,
    HelpersService: HelpersService,
    ImportJobsApiService: ImportJobsApiService,
    job: job,
    mappings: mappings
  });

  // TODO: update ui-router to 0.3.0 to avoid calling this manually
  this.$onInit();
}

ImportExportJobMappingsEditorModalController.prototype.$onInit = function() {
  this.vm = this._getVm(this);
};

ImportExportJobMappingsEditorModalController.prototype._getVm = function (initialData) {
  var _data = initialData || {},
    errorMessage = _data.errorMessage || '',
    copyButtonLabel = 'Copy to Clipboard',
    mappingsJson = _data.mappings ? JSON.stringify(_data.mappings, null, '  ') : {};

  return {
    errorMessage: errorMessage,
    mappingsJson: mappingsJson,
    copyButtonLabel: copyButtonLabel
  };
};

ImportExportJobMappingsEditorModalController.prototype.copy = function () {
  var self = this,
    copyText = angular.element('#job-mappings-editor-json');

  copyText.select();
  document.execCommand('copy');

  var copyButtonLabel = this.vm.copyButtonLabel;
  this.vm.copyButtonLabel = 'Copied!';

  this.$timeout(function () {
    self.vm.copyButtonLabel = copyButtonLabel;
  }, 2000);
};

ImportExportJobMappingsEditorModalController.prototype.cancel = function () {
  this.$uibModalInstance.close();
};

ImportExportJobMappingsEditorModalController.prototype.update = function () {
  var self = this;

  this.ImportJobsApiService.updateMappings(this.job.id, this.vm.mappingsJson)
    .then(function () {
      self.$uibModalInstance.close(true);
    }, self.handleUpdateError.bind(self));
};

ImportExportJobMappingsEditorModalController.prototype.handleUpdateError = function (response) {

  // Check if it's a JSON parse error so we can try and show some useful info
  if (response.data.message.indexOf('JSON parse error:') > -1) {
    this.vm.errorMessage = 'Error in mappings, please review your changes';

    // Check if we're given a line number
    var messageParts = response.data.message.split('line: ');

    if (messageParts.length > 1) {

      // Take last line mentioned, as this is usually the most relevant here (error can have multiple lines)
      this.vm.errorMessage += ' on line: ' + messageParts[messageParts.length - 1].split(']')[0];
      this.vm.errorMessage += '. We have tried to highlight the location below:';

      var line = messageParts[messageParts.length - 1].split(',')[0];
      this.HelpersService.selectAndScrollToTextareaLine(document.getElementById('job-mappings-editor-json'), line);
    } else {
      this.vm.errorMessage += '.';
    }
  } else {
    this.vm.errorMessage = 'Unable to update Job Mappings, please try again, or try again later.';
  }
};

ImportExportJobMappingsEditorModalController.prototype.formatJson = function () {
  try {
    this.vm.mappingsJson = JSON.stringify(JSON.parse(this.vm.mappingsJson), null, '  ');
  } catch(e) {
    this.vm.errorMessage = 'Error: Unable to format JSON, invalid structure. Please fix and try again.';
  }
};

ImportExportJobMappingsEditorModalController.$inject = [
  '$timeout',
  '$uibModalInstance',
  'HelpersService',
  'ImportJobsApiService',
  'job',
  'mappings'
];
